module.exports = __webpack_public_path__ + "de5fa297994118c3c43a2269d7ee5512.svg";